import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-2f0c33c6"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "main-container" };
const _hoisted_2 = { class: "left-container" };
const _hoisted_3 = { class: "center-container" };
const _hoisted_4 = {
    id: "MainTitle",
    class: "text-lg sm:text-xl md:text-2xl"
};
const _hoisted_5 = { class: "text-sm sm:text-base md:text-lg text-gray-500" };
const _hoisted_6 = { class: "text-sm sm:text-base md:text-lg text-gray-500" };
const _hoisted_7 = { class: "grid 2xl:flex 2xl:justify-center" };
const _hoisted_8 = { class: "p-4 2xl:w-9/12 2xl:max-h-full" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_10 = { class: "right-container" };
const _hoisted_11 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_hit_button = _resolveComponent("hit-button");
    const _component_hit_input = _resolveComponent("hit-input");
    const _component_hit_group_input = _resolveComponent("hit-group-input");
    const _component_hit_form = _resolveComponent("hit-form");
    const _component_hit_panel = _resolveComponent("hit-panel");
    const _component_hit_select = _resolveComponent("hit-select");
    const _component_hit_dialog = _resolveComponent("hit-dialog");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_hit_button, {
                    "suffix-icon": "back",
                    "icon-size": "lg",
                    color: "accent",
                    disabled: _ctx.companyCreationIsPending,
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('previousClick')))
                }, null, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('admin-ui.stepper_summary')), 1),
                _createElementVNode("span", null, [
                    _createElementVNode("h6", _hoisted_5, _toDisplayString(_ctx.t('admin-ui.summary_form_below_find_summary_user_and_company')), 1),
                    _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.t('admin-ui.summary_form_please_review_this_information_and_make_necessary_changes')), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_hit_panel, {
                            size: "maximized",
                            resizable: false,
                            title: _ctx.t('admin-ui.user')
                        }, {
                            body: _withCtx(() => [
                                _createVNode(_component_hit_form, {
                                    name: "userInfoForm",
                                    value: _ctx.objectFormData,
                                    "force-cancel-button-hidden": true,
                                    "force-save-button-hidden": true
                                }, {
                                    default: _withCtx(({ formData, }) => [
                                        _createVNode(_component_hit_group_input, {
                                            label: _ctx.t('admin-ui.first_name')
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_hit_input, {
                                                    value: formData.firstName,
                                                    "onUpdate:value": ($event) => ((formData.firstName) = $event),
                                                    class: "text-sm sm:text-base",
                                                    name: "firstName",
                                                    "inline-input": "",
                                                    disabled: true
                                                }, null, 8, ["value", "onUpdate:value"]),
                                                _createVNode(_component_hit_input, {
                                                    value: formData.lastName,
                                                    "onUpdate:value": ($event) => ((formData.lastName) = $event),
                                                    class: "text-sm sm:text-base",
                                                    label: _ctx.t('admin-ui.last_name'),
                                                    name: "lastName",
                                                    "inline-input": "",
                                                    disabled: true
                                                }, null, 8, ["value", "onUpdate:value", "label"])
                                            ]),
                                            _: 2
                                        }, 1032, ["label"]),
                                        _createVNode(_component_hit_input, {
                                            name: "usernameEmail",
                                            class: "text-sm sm:text-base",
                                            value: formData.usernameEmail || '',
                                            label: _ctx.t('admin-ui.email'),
                                            disabled: true
                                        }, null, 8, ["value", "label"])
                                    ]),
                                    _: 1
                                }, 8, ["value"])
                            ]),
                            _: 1
                        }, 8, ["title"]),
                        _hoisted_9,
                        _createVNode(_component_hit_panel, {
                            size: "maximized",
                            resizable: false,
                            title: _ctx.t('admin-ui.company')
                        }, {
                            body: _withCtx(() => [
                                _createVNode(_component_hit_form, {
                                    name: "CompanyInfoForm",
                                    class: "text-sm sm:text-base",
                                    value: _ctx.objectFormData,
                                    "force-cancel-button-hidden": true,
                                    "force-save-button-hidden": true
                                }, {
                                    default: _withCtx(({ formData }) => [
                                        _createVNode(_component_hit_select, {
                                            name: "userLanguageSystem",
                                            class: "text-sm sm:text-base",
                                            value: _ctx.HitUtils.kebabToSnake(_ctx.myObject.userSystemLanguage),
                                            "label-fields": ['designation'],
                                            options: _ctx.HitLanguageUtils.getSupportedLanguageOptions(),
                                            label: _ctx.t('admin-ui.language_system'),
                                            filterable: false,
                                            clearable: false,
                                            disabled: true
                                        }, null, 8, ["value", "options", "label"]),
                                        _createVNode(_component_hit_group_input, {
                                            label: _ctx.t('admin-ui.vat_number')
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_hit_input, {
                                                    name: "vatNumber",
                                                    class: "text-sm sm:text-base",
                                                    value: formData.vatNumber || '',
                                                    "inline-input": "",
                                                    disabled: true
                                                }, null, 8, ["value"]),
                                                _createVNode(_component_hit_input, {
                                                    name: "designationLegal",
                                                    class: "text-sm sm:text-base",
                                                    value: formData.designationLegal,
                                                    label: _ctx.t('admin-ui.legal_designation'),
                                                    "inline-input": "",
                                                    disabled: true
                                                }, null, 8, ["value", "label"])
                                            ]),
                                            _: 2
                                        }, 1032, ["label"]),
                                        _createVNode(_component_hit_input, {
                                            name: "street",
                                            class: "text-sm sm:text-base",
                                            value: formData.street || '',
                                            label: _ctx.t('admin-ui.street'),
                                            disabled: true
                                        }, null, 8, ["value", "label"]),
                                        _createVNode(_component_hit_group_input, {
                                            label: _ctx.t('admin-ui.house_number')
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_hit_input, {
                                                    name: "houseNumber",
                                                    class: "text-sm sm:text-base",
                                                    value: formData.houseNumber || '',
                                                    "inline-input": "",
                                                    disabled: true
                                                }, null, 8, ["value"]),
                                                _createVNode(_component_hit_input, {
                                                    name: "boxNumber",
                                                    class: "text-sm sm:text-base",
                                                    value: formData.boxNumber || '',
                                                    label: _ctx.t('admin-ui.box_number'),
                                                    "inline-input": "",
                                                    disabled: true
                                                }, null, 8, ["value", "label"])
                                            ]),
                                            _: 2
                                        }, 1032, ["label"]),
                                        _createVNode(_component_hit_group_input, {
                                            label: _ctx.t('admin-ui.post_code')
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_hit_input, {
                                                    name: "postCode",
                                                    class: "text-sm sm:text-base",
                                                    value: formData.postCode || '',
                                                    "inline-input": "",
                                                    disabled: true
                                                }, null, 8, ["value"]),
                                                _createVNode(_component_hit_input, {
                                                    name: "city",
                                                    class: "text-sm sm:text-base",
                                                    value: formData.city || '',
                                                    label: _ctx.t('admin-ui.city'),
                                                    "inline-input": "",
                                                    disabled: true
                                                }, null, 8, ["value", "label"])
                                            ]),
                                            _: 2
                                        }, 1032, ["label"]),
                                        _createVNode(_component_hit_group_input, {
                                            label: _ctx.t('admin-ui.phone')
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_hit_input, {
                                                    name: "phone",
                                                    class: "text-sm sm:text-base",
                                                    value: formData.phone || '',
                                                    "inline-input": "",
                                                    disabled: true
                                                }, null, 8, ["value"]),
                                                _createVNode(_component_hit_input, {
                                                    name: "mobile",
                                                    class: "text-sm sm:text-base",
                                                    value: formData.mobile || '',
                                                    label: _ctx.t('admin-ui.mobile'),
                                                    "inline-input": "",
                                                    disabled: true
                                                }, null, 8, ["value", "label"])
                                            ]),
                                            _: 2
                                        }, 1032, ["label"]),
                                        _createVNode(_component_hit_input, {
                                            name: "activity",
                                            class: "text-sm sm:text-base",
                                            value: formData.activity || '',
                                            label: _ctx.t('admin-ui.activity'),
                                            "inline-input": "",
                                            disabled: true
                                        }, null, 8, ["value", "label"]),
                                        (_ctx.enableReferralSystem === 'true')
                                            ? (_openBlock(), _createBlock(_component_hit_input, {
                                                key: 0,
                                                name: "referralCode",
                                                class: "text-sm sm:text-base",
                                                value: formData.referralCode || '',
                                                label: _ctx.t('admin-ui.referral_code'),
                                                "inline-input": "",
                                                disabled: true
                                            }, null, 8, ["value", "label"]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }, 8, ["value"])
                            ]),
                            _: 1
                        }, 8, ["title"])
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_hit_button, {
                    label: _ctx.t('admin-ui.create-account'),
                    "prefix-icon": "add",
                    "icon-size": "base",
                    color: "accent",
                    disabled: _ctx.disableCreateAccountButton,
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.createAccount()))
                }, null, 8, ["label", "disabled"])
            ]),
            (_ctx.finalApiMakingRequest)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_hit_dialog, {
                        visible: _ctx.finalApiMakingRequest,
                        "onUpdate:visible": _cache[2] || (_cache[2] = ($event) => ((_ctx.finalApiMakingRequest) = $event)),
                        color: "accent",
                        "ok-button-color": "accent",
                        title: _ctx.finalApiTitleToShow,
                        message: _ctx.finalApiMessageToShow,
                        "ok-button-label": _ctx.finalApiLabelConfirmButton,
                        "show-ok-button": _ctx.finalApiShowConfirmButton,
                        "enable-close-dialog": _ctx.finalApiAllowToLeaveDialog
                    }, null, 8, ["visible", "title", "message", "ok-button-label", "show-ok-button", "enable-close-dialog"])
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
